import { userConstants } from "_constants";

/**
 * Reducer function to handle user-related actions and update the state accordingly.
 *
 * @param {Object} state - The current state of the users.
 * @param {Object} action - The action dispatched.
 * @param {string} action.type - The type of action being dispatched.
 * @param {Object} [action.user] - The user data associated with the action.
 * @param {string} [action.error] - The error message associated with the action.
 * @param {string} [action.id] - The ID of the user being deleted.
 * @returns {Object} The new state of the users.
 */
export function users(state = {}, action) {
  switch (action.type) {
    case userConstants.GETALL_REQUEST:
      return {
        loading: true,
        error: null,
      };
    case userConstants.GETALL_SUCCESS:
      return {
        items: action.user,
      };
    case userConstants.LOGIN_REQUEST:
    case userConstants.LOGIN_SUCCESS:
      return {
        error: null,
      };
    case userConstants.GETALL_FAILURE:
    case userConstants.LOGIN_FAILURE:
      return {
        error: action.error,
      };

    //UPDATE USER PASSWORD
    case userConstants.UPDATE_PASSWORD_REQUEST:
      return {
        loading: true,
      };
    case userConstants.UPDATE_PASSWORD_SUCCESS:
      return {
        loading: false,
        items: action.user,
      };
    case userConstants.UPDATE_PASSWORD_FAILURE:
      return {
        loading: false,
        error: action.error,
      };

    //DELETE
    case userConstants.DELETE_REQUEST:
      // add 'deleting:true' property to user being deleted
      return {
        ...state,
        items: state.items.map((user) =>
          user.id === action.id ? { ...user, deleting: true } : user
        ),
      };
    case userConstants.DELETE_SUCCESS:
      // remove deleted user from state
      return {
        items: state.items.filter((user) => user.id !== action.id),
      };
    case userConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to user
      return {
        ...state,
        items: state.items.map((user) => {
          if (user.id === action.id) {
            // make copy of user without 'deleting:true' property
            const { deleting, ...userCopy } = user;
            // return copy of user with 'deleteError:[error]' property
            return { ...userCopy, deleteError: action.error };
          }

          return user;
        }),
      };
    case userConstants.CLEAR_ERROR:
      return {
        ...state,
        error: "", // Clear the error state when this action is dispatched
      };

    // two-factor authenticate
    case userConstants.TWO_FACTOR_REQUEST:
      return {
        loading: true,
        error: null,
      };
    case userConstants.TWO_FACTOR_SUCCESS:
      return {
        loading: false,
        items: action.user,
      };
    case userConstants.TWO_FACTOR_FAILURE:
      return {
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}
